import React from "react";
import "./discussion.css";
import Photo from "../../assets/images/Photo.png";

const DiscussionItem = () => {
  return (
    <div className="discussion_item">
      <h4>
        Do you find a painting changes as you step forward or backward to view
        it?
      </h4>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut eget
        porttitor urna. In gravida, orci vel pretium lobortis, lorem purus
        auctor mauris, in sollicitudin orci enim vel enim...
      </p>
      <div className="d-flex justify-content-between align-items-center">
        <img src={Photo} alt="" />
        <span>Join Group</span>
      </div>
    </div>
  );
};

export default DiscussionItem;
